import { useLocation, Link } from "react-router-dom";

export default function NotFound() {
  const location = useLocation();

  return (
    <div className="min-h-screen bg-background-50 flex flex-col items-center justify-center text-center px-4">
      <h1 className="absolute text-9xl md:text-[12rem] font-heading font-black text-background-100 select-none pointer-events-none">
        404
      </h1>
      <div className="relative z-10">
        <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-4">
          <i className="ri-error-warning-line text-3xl text-primary-600"></i>
        </div>
        <h1 className="text-xl md:text-2xl font-heading font-semibold text-foreground-900 mt-6">页面未找到</h1>
        <p className="mt-2 text-sm text-foreground-500 font-mono">{location.pathname}</p>
        <p className="mt-4 text-base text-foreground-600">您访问的页面不存在或已被移除</p>
        <Link
          to="/"
          className="inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 hover:bg-primary-600 text-background-50 rounded-lg text-sm font-medium transition-colors mt-6 cursor-pointer whitespace-nowrap"
        >
          <div className="w-5 h-5 flex items-center justify-center">
            <i className="ri-home-line"></i>
          </div>
          返回首页
        </Link>
      </div>
    </div>
  );
}